import { CommonModule, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
    Configurations,
    CropFocus,
    Stops,
} from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { ItineraryDay } from '@generated/graphql';
import { RichTextDocumentComponent } from '../../../contentful-dynamic/rich-text/rich-text-document/rich-text-document.component';
import { LazyPictureComponent } from '../../../lazy-image/components/lazy-picture/lazy-picture.component';

@Component({
    selector: 'app-trips-itinerary-day',
    templateUrl: './trips-itinerary-day.component.html',
    imports: [
        NgClass,
        RichTextDocumentComponent,
        LazyPictureComponent,
        CommonModule,
    ],
    host: { ngSkipHydration: 'true' },
})
export class TripsItineraryDayComponent implements OnInit {
    @Input() day: ItineraryDay;
    @Input() dayNumber: number;
    featuredImageConfiguration: Configurations;
    constructor() {}

    ngOnInit(): void {
        this.featuredImageConfiguration = {
            [Stops.FALLBACK]: {
                image: this.day?.featuredImage,
                ratioHeight: 1,
                ratioWidth: 1,
                widthLqip: 32,
                width: 1200,
                width2x: 1200,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
            [Stops.BASE]: {
                image: this.day?.featuredImage,
                ratioHeight: 1,
                ratioWidth: 1,
                widthLqip: 32,
                width: 800,
                width2x: 1200,
                width3x: 1600,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
            [Stops.MD]: {
                image: this.day?.featuredImage,
                ratioHeight: 9,
                ratioWidth: 16,
                widthLqip: 32,
                width: 400,
                width2x: 800,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
            [Stops.LG]: {
                image: this.day?.featuredImage,
                ratioHeight: 9,
                ratioWidth: 16,
                widthLqip: 32,
                width: 800,
                width2x: 1200,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
            [Stops.XL]: {
                image: this.day?.featuredImage,
                ratioHeight: 9,
                ratioWidth: 16,
                widthLqip: 32,
                width: 800,
                width2x: 1600,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
            [Stops.XXL]: {
                image: this.day?.featuredImage,
                ratioHeight: 9,
                ratioWidth: 16,
                widthLqip: 32,
                width: 800,
                width2x: 1600,
                focus:
                    (this.day?.featuredImageCropFocus as CropFocus) || 'center',
            },
        };
    }
}
